import { CoverImage } from "src/model/api/cover-image.model";
import { appApiSlice } from "src/api/app-ApiSlice";

export const offerApiSlice = appApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCoverImages: builder.query<CoverImage[], number | void>({
      query: (projectId: number) => `/v1/offer/cover-images?project_id=${projectId}`,
    }),
  }),
  overrideExisting: false,
});

export const { useGetCoverImagesQuery } = offerApiSlice;